export default {
  serviceHistory: {},
  serviceHistories: []
}
